import React, { useEffect } from 'react';
import Settings from '../../../Settings/Settings'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Style from './Styles/CompatibleProductComponentStyle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/Add';
import $ from "jquery";
import LoadingComponent from '../../LoadingComponent/LoadingComponent';
import UploadIcon from '@mui/icons-material/Upload';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

export default function AddCompatibleProduct(props) {
    const classes = Style();
    const [imagesArray, setImagesArray] = React.useState([])
    const [filesArray, setFilesArray] = React.useState([])
    const [uploadingImages, setUploadingImages] = React.useState(false)
    const [existingImages, setExistingImages] = React.useState([])
    const [confirmDeleteImage, setConfirmDeleteImage] = React.useState({})
    useEffect(() => {
        getImages()
        }, []);
    const componentConstants = {
        ...props.componentConstants
      }
    
      const componentMethods = {
          ...props.componentMethods
      }
    
      const componentProps = {
          ...props.componentProps
      }
    const addImage = () => {
        let input = document.createElement('input')
        input.type = 'file';
        input.accept="image/*";
        input.click();
        input.onchange = () => {
            let url = URL.createObjectURL(input.files[0])
            let imgArr = [...imagesArray];
            imgArr.push(url);
            setImagesArray(imgArr)
            let fileArr = [...filesArray];
            fileArr.push(input);
            setFilesArray(fileArr)
        }
    }
    const postImages = () => {
        setUploadingImages(true)
        const formData = new FormData();
        for (let i in filesArray) {
            formData.append('image' + i, filesArray[i].files[0]);
        }
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            let accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
            $.ajax({
                url: Settings.API_URL + Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS_IMAGES + props.shopCompatibleProductsID  + accountToken,
                type: 'POST',
                data: formData,
                success: function (data) {
                    setUploadingImages(false)
                    setFilesArray([])
                    setImagesArray([])
                    getImages()
                },
                error: function (request, status, error) {
                  componentMethods.addError(componentConstants.language["LANG_ERROR_COULD_NOT_LOAD_IMAGE"])
                },
                cache: false,
                contentType: false,
                processData: false
            });
        }
    }
    const getImages = () => {
        componentMethods.ajax(
            Settings.API_URL + Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS_IMAGES + props.shopCompatibleProductsID,
        {},
        'GET',null,(data) => {
            setExistingImages(data.items)
        })
    }
    const deleteImageAction = (imageID) => {
        let accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash

        componentMethods.ajax(
            Settings.API_URL + Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS_IMAGES + imageID + accountToken,
        {},
        'DELETE',null,(data) => {
            getImages()
        })
    }

    const getConfirmDeleteImage = (imageID) => {
        return confirmDeleteImage[imageID] === true;
    } 

    const confirmDeleteImageAsk = (imageID) => {
        let confDel = {...confirmDeleteImage}
        confDel[imageID] = !confDel[imageID]
        setConfirmDeleteImage(confDel);
    }
  return (<div style={classes.rootAddress}><React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    {componentConstants.language.LANG_NEW_IMAGES}
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    {uploadingImages ?
                        <LoadingComponent />
                    :
                    
                        <React.Fragment>
                            {
                                imagesArray.map((item, index) => {
                                    return <React.Fragment key={index}>
                                                <img src={item} style={classes.img} />
                                            </React.Fragment>
                                })
                            }
                            <Button fullWidth color="secondary" onClick={() => {addImage()} } style={{height: 150, width:150}} ><AddIcon /></Button>
                            <Button fullWidth color="secondary" variant="contained" onClick={() => {postImages()} }><UploadIcon /> {componentConstants.language.LANG_UPLOAD_IMAGES}</Button>
                        </React.Fragment>
                    }
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    {componentConstants.language.LANG_EXISTING_IMAGES}
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    {
                        existingImages.map((item, index) => {
                            return <div key={index} style={classes.imgContainer}>
                                        <img src={Settings.API_URL + Settings.API_ENDPOINT_FILE + item.shopCompatibleProductsImagesPath} style={classes.img} />

                                        {
                                        !getConfirmDeleteImage(item.shopCompatibleProductsImagesID)?
                                            <IconButton onClick={(e) => {confirmDeleteImageAsk(item.shopCompatibleProductsImagesID)}}><DeleteIcon /></IconButton>
                                        :
                                        <React.Fragment>
                                            <Button color="primary" variant="contained" onClick={(e) => {deleteImageAction(item.shopCompatibleProductsImagesID)}}><DeleteIcon />{componentConstants.language.LANG_DELETE}</Button>
                                            <Button color="secondary" variant="outlined" onClick={(e) => {confirmDeleteImageAsk(item.shopCompatibleProductsImagesID)}}>{componentConstants.language.LANG_CANCEL}</Button>
                                        </React.Fragment>
                                        }
                                    </div>
                        })
                    }
                </Grid>
                </Grid>
            </React.Fragment>
            </div>
  );
}